"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9.714 3.583A2.652 2.652 0 0112 2.25c.938 0 1.804.506 2.286 1.333l8.113 14.07c.465.837.468 1.864.007 2.704a2.657 2.657 0 01-2.3 1.393H3.886a2.654 2.654 0 01-2.291-1.393 2.81 2.81 0 01.013-2.715l8.107-14.06zM2.912 18.38a1.306 1.306 0 00-.003 1.254c.207.38.586.61.984.615h16.205c.407-.005.786-.236.993-.615.213-.387.212-.867.003-1.243L12.989 4.335A1.15 1.15 0 0012 3.75c-.4 0-.774.219-.988.584l-8.1 14.047zM11.25 10v4a.75.75 0 101.5 0v-4a.75.75 0 10-1.5 0zm.75 8a1 1 0 100-2 1 1 0 000 2z"
  }));
};
SvgAlertTriangle.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgAlertTriangle.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgAlertTriangle;
exports["default"] = _default;
module.exports = exports.default;